import SgdfFunctionBadge from './function-badge.component.js';
export * from './function-badge.component.js';
export default SgdfFunctionBadge;
SgdfFunctionBadge.define('sgdf-function-badge');
//# sourceMappingURL=function-badge.js.map